import { ColorAttribute, getAttributesToSerialize } from '../attributes';
import { TimeInvariantBase } from '../TimeInvariantBase';

export class ColorMap extends TimeInvariantBase {
    override _name = 'ColorMap';
    override _classType = 'ColorMap';

    @ColorAttribute()
    accessor sourceColor: number = 0x000000;

    @ColorAttribute()
    accessor targetColor: number = 0x000000;

    // eslint-disable-next-line no-useless-constructor
    constructor(settings) {
        super(settings);
    }

    override get readonlyProperties() {
        return [];
    }

    override get propertiesToSerialize() {
        return getAttributesToSerialize(this);
    }
}
